const TOTAL_TIMEOUT_MS = 6000;
const GEO_TIMEOUT_MS = 4000;
const FETCH_TIMEOUT_MS = 4000;

export const getLocation = (): Promise<string> => {
  const fallback = new Promise<string>((resolve) =>
    setTimeout(() => resolve(""), TOTAL_TIMEOUT_MS),
  );

  const acquire = new Promise<string>((resolve) => {
    if (!navigator.geolocation) return resolve("");

    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
            {
              headers: { "Accept-Language": "en" },
              signal: controller.signal,
            },
          );
          const json = await res.json();
          const city =
            json.address?.city ||
            json.address?.town ||
            json.address?.village ||
            "";
          const stateCode =
            (json.address?.["ISO3166-2-lvl4"] ?? "").split("-")[1] ?? "";
          resolve(city && stateCode ? `${city}, ${stateCode}` : "");
        } catch {
          resolve("");
        } finally {
          clearTimeout(timer);
        }
      },
      () => resolve(""),
      { timeout: GEO_TIMEOUT_MS, maximumAge: 60_000 },
    );
  });

  return Promise.race([acquire, fallback]);
};
